import qs from 'qs';
import { INVENTORY_INFO, ORDER_ITEM_OPTIONS } from '../../constants/endpoints';
import { receiveUnevenExchangeData } from '../unevenExchanges';

export const RESET_ITEM_EXCHANGE_INFO = 'RESET_ITEM_EXCHANGE_INFO';
export const SWITCH_CURRENT_EXCHANGE_ITEM_ID = 'SWITCH_CURRENT_EXCHANGE_ITEM_ID';
export const UPDATE_ITEM_EXCHANGE_INFO = 'UPDATE_ITEM_EXCHANGE_INFO';
export const UPDATE_INVENTORY_INFO_ERROR = 'UPDATE_INVENTORY_INFO_ERROR';
export const TOGGLE_EXCHANGE_SIDEBAR = 'TOGGLE_EXCHANGE_SIDEBAR';
export const UPDATE_EXCHANGE_COMMENT = 'UPDATE_EXCHANGE_COMMENT';
export const SET_IS_FETCHING_INVENTORY = 'SET_IS_FETCHING_INVENTORY';

export const filterOptions = (options, hiddenOptions) =>
  options.filter((option) => !hiddenOptions.includes(option.code.toLowerCase()));

export const exchangeOptionCheck = (inventory, option) =>
  option.values.reduce(
    (availableOptions, value) => ({
      ...availableOptions,
      [value]: inventory.some((item) => item.attributes[option.code] === value),
    }),
    {},
  );

export const resetItemExchangeInfo = (itemId) => ({
  type: RESET_ITEM_EXCHANGE_INFO,
  data: { itemId },
});

export const switchCurrentExchangeItem = (itemId) => ({
  type: SWITCH_CURRENT_EXCHANGE_ITEM_ID,
  data: { itemId },
});

export const fetchInventoryInfo = (itemId) => async (dispatch, getState) => {
  const {
    orderInfo: { currentOrderNumber } = {},
    page: { locale, browserFingerprint, overrideCode } = {},
    retailerSettings: { name } = {},
  } = getState();

  const response = await fetch(
    INVENTORY_INFO({
      retailerName: name.toLowerCase(),
      itemId,
      params: qs.stringify({
        locale,
        order_number: currentOrderNumber,
        ...(overrideCode ? { return_override_code: overrideCode } : {}),
      }),
    }),
    {
      method: 'GET',
      headers: {
        'narvar-tfid': browserFingerprint,
      },
    },
  );
  const json = response.json();
  return json;
};

export const fetchOrderItemOptions = (itemId) => async (_, getState) => {
  const {
    orderInfo: { currentOrderNumber: orderNumber } = {},
    page: { locale, browserFingerprint } = {},
    retailerSettings: { name } = {},
  } = getState();

  const response = await fetch(
    ORDER_ITEM_OPTIONS({
      retailerName: name.toLowerCase(),
      itemId,
      orderNumber,
      params: qs.stringify({ locale }),
    }),
    {
      method: 'GET',
      headers: {
        'narvar-tfid': browserFingerprint,
      },
    },
  );
  const json = response.json();
  return json;
};

export const updateItemExchangeInfo = (itemId) => async (dispatch, getState) => {
  const {
    page: { productType } = {},
    returnsSettings: {
      [productType]: {
        exchange: { unevenExchanges, hidden_options: hiddenOptions = [] } = {},
      } = {},
    } = {},
    exchange: { items: { [itemId]: currentItemExchangeInfo } = {} } = {},
  } = getState();

  if (!currentItemExchangeInfo) {
    try {
      dispatch({
        type: SET_IS_FETCHING_INVENTORY,
        data: {
          isFetchingInventory: true,
        },
      });
      const { inventory, options } = await dispatch(fetchInventoryInfo(itemId));

      if (inventory) {
        const filteredOptions = filterOptions(options, hiddenOptions);
        await dispatch({
          type: UPDATE_ITEM_EXCHANGE_INFO,
          data: {
            itemId,
            inventory,
            options: filteredOptions,
            exchangeOptions: filteredOptions.reduce(
              (allOptions, option) => ({
                ...allOptions,
                [option.code]: exchangeOptionCheck(inventory, option),
                [`${option.code}SortOrder`]: option.values,
              }),
              {},
            ),
          },
        });
        if (unevenExchanges) {
          dispatch(receiveUnevenExchangeData({ inventory, options }));
        }
      } else {
        dispatch({
          type: UPDATE_INVENTORY_INFO_ERROR,
          data: { itemId },
        });
      }
    } catch (error) {
      dispatch({
        type: UPDATE_INVENTORY_INFO_ERROR,
        data: { itemId },
      });
    } finally {
      dispatch({
        type: SET_IS_FETCHING_INVENTORY,
        data: {
          isFetchingInventory: false,
        },
      });
    }
  }
  return dispatch(switchCurrentExchangeItem(itemId));
};

export const toggleExchangeSideBar = (isOpen) => ({
  type: TOGGLE_EXCHANGE_SIDEBAR,
  data: { isOpen },
});

export const updateExchangeComment = (itemId, comment) => ({
  type: UPDATE_EXCHANGE_COMMENT,
  data: { itemId, comment },
});
